module.exports = __webpack_public_path__ + "static/media/a1mV1egnQwOqxZZZvhVo_street.84dd7521.jpg";